// removed by extract-text-webpack-plugin
module.exports = {"Main":"resetPassword__Main__3Kdw8"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/ResetPassword/resetPassword.css
// module id = 1683
// module chunks = 2